import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useGatewayCardContext } from '../gateway-card.context';
import { staticItems } from '../constants';
import { GatewayStatics } from 'features/gateways/types/gateway-statics.types';
import { addCommas } from '@persian-tools/persian-tools';

const Statics: React.FC = () => {
    const {
        loading,
        gateway: { statics },
    } = useGatewayCardContext();

    return (
        <Grid container sx={{ mt: 1.5 }}>
            {staticItems.map((item, index: number) => {
                return (
                    <Grid item xs={6} key={item.name + ''}>
                        <Box
                            sx={{
                                px: 2,
                                py: 1.25,
                                borderInlineEnd: (theme) =>
                                    index % 2 === 0
                                        ? `1px solid ${theme.palette.divider}`
                                        : '',
                                borderBottom: (theme) =>
                                    index < 2
                                        ? `1px solid ${theme.palette.divider}`
                                        : '',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 11,
                                    lineHeight: 1.4,
                                    color: 'text.secondary',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                }}
                            >
                                {item.label}
                            </Typography>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.75,
                                    mt: 0.5,
                                    '& i': {
                                        fontSize: 14,
                                        color: 'text.light',
                                    },
                                }}
                            >
                                {item.icon}
                                <Typography
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: 600,
                                        fontSize: 14,
                                    }}
                                >
                                    {statics &&
                                    statics[
                                        item.name as keyof GatewayStatics
                                    ] !== undefined
                                        ? addCommas(
                                              statics[
                                                  item.name as keyof GatewayStatics
                                              ],
                                          )
                                        : '0'}
                                    {' ' + item.value_prefix}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default Statics;
